import React, { useContext } from 'react';
import LanguageContext from 'context/LanguageContext';

import Spinner from 'components/Spinner/Spinner';

export default function CareerCard({ job, isLoading }) {
  const { language } = useContext(LanguageContext);

  function handleMailButton() {
    switch (language) {
      case 'it':
        return 'Invia candidatura';
      case 'en':
        return 'Apply for this job';
      default:
        return '';
    }
  }

  return (
    <div className="flex flex-col justify-between p-4 bg-white border border-gray-100 shadow-md rounded-xl focus:outline-none focus:ring hover:border-gray-200 hover:ring-1 hover:ring-gray-200">
      {isLoading ? (
        <div className="flex items-center justify-center ">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4">
            {job.titolo && (
              <div className="flex items-center justify-start gap-4">
                <h6 className="mt-2 text-2xl font-bold">{job.titolo}</h6>
              </div>
            )}
            {job.mansione && (
              <div>
                <p className="font-bold">
                  {language === 'it' && 'Mansione'}
                  {language === 'en' && 'Job'}
                </p>
                <p className="">{job.mansione}</p>
              </div>
            )}
            {job.requisiti && (
              <div>
                <p className="font-bold">
                  {language === 'it' && 'Requisiti'}
                  {language === 'en' && 'Requirements'}
                </p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: job.requisiti,
                  }}
                />
              </div>
            )}
            {job.location && (
              <div>
                <p className="font-bold">Location</p>
                <p className="">{job.location}</p>
              </div>
            )}
            {job.tipologia_di_contratto && (
              <div>
                <p className="font-bold">
                  {language === 'it' && 'Tipologia di contratto'}
                  {language === 'en' && 'Employment Contract'}
                </p>
                <p className="">{job.tipologia_di_contratto}</p>
              </div>
            )}
          </div>
          <a
            href="mailto:cv@edrivelab.it"
            className="w-full px-2 py-2 mx-auto mt-4 text-center transition-all border border-black rounded-md hover:bg-black hover:text-white"
          >
            {handleMailButton()}
          </a>
        </>
      )}
    </div>
  );
}
